import { render, staticRenderFns } from "./PluginUblSettingsEmail.vue?vue&type=template&id=4cbb2886"
import script from "./PluginUblSettingsEmail.vue?vue&type=script&lang=ts"
export * from "./PluginUblSettingsEmail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cbb2886')) {
      api.createRecord('4cbb2886', component.options)
    } else {
      api.reload('4cbb2886', component.options)
    }
    module.hot.accept("./PluginUblSettingsEmail.vue?vue&type=template&id=4cbb2886", function () {
      api.rerender('4cbb2886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/PluginUblSettingsEmail.vue"
export default component.exports